import Base from './base'
import { TeamPrivacySettings as TeamPrivacySettingsType } from '../types/user'

export default class TeamPrivacySettings extends Base {
  async get(): Promise<TeamPrivacySettingsType> {
    const response = await this.api.get('team_privacy_setting.json')
    return response?.data
  }
}
